import styled from 'styled-components';

import { darken } from 'polished';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

export const DateWrapper = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
`;

export const DateChip = styled(Typography)`
  padding: 10px;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.datePickerBackground};
  background-color: ${({ theme }) => theme.colors.differentBackground};
  text-align: center;
  cursor: pointer;
  transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`},
    color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    background-color: ${({ theme }) => theme.colors.box};
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.white};

    &:hover {
      background-color: ${({ theme }) => theme.colors.accentHover};
    }
  }

  &.dark {
    color: ${({ theme }) => theme.colors.differentBackground};
    background-color: ${({ theme }) => theme.colors.datePickerBackground};

    &:hover {
      background-color: ${({ theme }) =>
        darken(0.25, theme.colors.datePickerBackground)};
    }

    &.active {
      background-color: ${({ theme }) => theme.colors.accent};
      color: ${({ theme }) => theme.colors.white};

      &:hover {
        background-color: ${({ theme }) => theme.colors.accentHover};
      }
    }
  }
`;

export const IconWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.iconBackground};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 10px;
    height: auto;
  }
`;

export const Separator = styled.span`
  display: block;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.border};
  margin: 20px auto;
`;

export const FilterSelector = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
`;

export const ChipSelector = styled(Typography)`
  cursor: pointer;
  padding: 10px;
  width: 100%;
  border-radius: 18px;
  text-align: center;
  color: ${({ theme }) => theme.colors.differentBackground};
  background-color: ${({ theme }) => theme.colors.datePickerBackground};
  transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`},
    color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

  &.active {
    color: ${({ theme }) => theme.colors.datePickerBackground};
    background-color: ${({ theme }) => theme.colors.differentBackground};
  }
`;

export const YearSelectorWrapper = styled(Flex)`
  margin-bottom: 20px;

  .year-dropdown {
    cursor: pointer;
  }

  .year-text {
    &.has-changes {
      color: ${({ theme }) => theme.colors.differentBackground};
    }
  }
`;
